export default {
  PERMISSION_REQUEST: 'APP/PERMISSIONSMANAGE/PERMISSIONSMANAGE_REQUEST',
  PERMISSION_SUCCESS: 'APP/PERMISSIONSMANAGE/PERMISSIONSMANAGE_SUCCESS',
  PERMISSION_ERROR: 'APP/PERMISSIONSMANAGE/PERMISSIONSMANAGE_ERROR',
};
